import boardInfoService from '../services/boardInfoService';

const handleResponse = (result, fallbackMessage) => {
  if (!result?.success) {
    const error = new Error(result?.message || fallbackMessage);
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchBoardInfo = async () => {
  const result = await boardInfoService.getBoardInfo();
  return handleResponse(result, 'Kurul bilgisi alınamadı');
};

export const updateBoardInfo = async (payload) => {
  const result = await boardInfoService.updateBoardInfo(payload);
  return handleResponse(result, 'Kurul bilgisi güncellenemedi');
};

export default {
  fetchBoardInfo,
  updateBoardInfo,
};

